import { PetBreakdownReport } from 'model/ClientAndPetsReport';

export interface PetBreakdownReportState {
    report: PetBreakdownReport;
    status: PetBreakdownReportStatus;
    loading: boolean;
}

export enum PetBreakdownReportStatus {
    Initial,
    Getting,
    GettingSuccess,
    Error
}
